<script lang="ts" setup>
  import { computed, ref, onMounted } from 'vue'
  import { ChevronLeft, ChevronRight } from 'lucide-vue-next'
  import Button from '@/components/ui/button/Button.vue'
  import { useThemeColor } from '@/composables/useThemeColor'

  const props = defineProps({
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    showPrevNextButtons: {
      type: Boolean,
      required: false,
      default: true
    },
    showPageButtons: {
      type: Boolean,
      required: false,
      default: true
    }
  })

  onMounted(() => {
    console.log('props', props)
  })

  const emit = defineEmits(['updatePage'])

  const themeColor = computed(() => useThemeColor().value)
  const width = ref(window.innerWidth)
  const maxPagesToShow = ref(7)
  const currentPageSet = ref(1)

  const compactMode = computed(() => {
    return width.value < 768
  })

  const displayedPages = computed(() => {
    const startPage = (currentPageSet.value - 1) * maxPagesToShow.value + 1
    const endPage = Math.min(startPage + maxPagesToShow.value - 1, props.totalPages)
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
  })

  const updateCurrentPageSet = (direction: string) => {
    console.log('updateCurrentPageSet', direction, props)
    if (direction === 'next' && props.currentPage < props.totalPages) {
      emit('updatePage', props.currentPage + 1)
      if (props.currentPage >= currentPageSet.value * maxPagesToShow.value) {
        currentPageSet.value++
      }
    } else if (direction === 'prev' && props.currentPage > 1) {
      emit('updatePage', props.currentPage - 1)
      if (props.currentPage <= (currentPageSet.value - 1) * maxPagesToShow.value + 1) {
        currentPageSet.value--
      }
    }
  }

  const goToPage = (page: number) => {
    emit('updatePage', page)
  }
</script>

<template>
  <nav class="mb-1 flex justify-end">
    <ul
      v-show="totalPages > 1"
      class="flex list-none"
    >
      <li
        v-if="showPrevNextButtons"
        class="page-item mr-1"
      >
        <Button
          variant="outline"
          size="icon"
          :disabled="currentPage === 1"
          @click="updateCurrentPageSet('prev')"
        >
          <ChevronLeft class="h-4 w-4" />
        </Button>
      </li>
      <template
        v-for="page in displayedPages"
        :key="page"
      >
        <li
          v-if="showPageButtons"
          class="mr-1 text-center"
        >
          <Button
            size="icon"
            :class="
              page == currentPage
                ? `bg-${themeColor}-600 hover:bg-${themeColor}-800`
                : 'bg-gray-300 hover:bg-gray-500'
            "
            @click="goToPage(page)"
          >
            {{ page }}
          </Button>
        </li>
      </template>
      <li
        v-if="showPrevNextButtons"
        class="page-item"
      >
        <Button
          variant="outline"
          size="icon"
          :disabled="currentPage === totalPages"
          @click="updateCurrentPageSet('next')"
        >
          <ChevronRight class="h-4 w-4" />
        </Button>
      </li>
    </ul>
  </nav>
</template>
